import { action, atom } from '@reatom/framework'

export type TradingNavigationTab =
  | 'trading'
  | 'analytics'
  | 'orders'
  | 'positions'
  | 'recent-pairs'

export const tradingNavigationAtom = atom<TradingNavigationTab | undefined>(
  'trading',
  'tradingNavigationAtom',
)

/**
 * Which of the trading screens the phone is on.
 *
 * Four of the five tabs used to answer a tap on the website by offering the
 * desktop app, and — in the app, where the offer was skipped — by doing
 * nothing at all: the tab was never set either way. Both are gone; a tap
 * changes the tab, which is what a tab is for.
 */
export const changeTradingTabAction = action(
  (ctx, tab: TradingNavigationTab) => {
    tradingNavigationAtom(ctx, tab)
  },
  'changeTradingTabAction',
)
